<template>
  <div class="question-box">
    <div class="question-title">
      <div style="display:flex;">
        {{index+1}}.
        <span v-html="questionContent.content"></span>
      </div>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="question-content-option">
      <div class="question-option" v-for="(item,i) in optionsContent" :class="isRight(i)" :key="i">
        <el-radio v-model="singleAnswer" :label="i" :disabled="singleAnswer===i?false:true">
          <span class="question-option-sort">{{optionMap[i]}}.</span>
          <span class="question-option-content">
            {{item.content}}
          </span>
        </el-radio>
        <viewer :images="item.file" class="option-img-box">
          <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
        </viewer>
      </div>
    </div>
    <div class="question-answer" :class="isRight('')">
      <span class="it-li">正确答案：{{optionMap[analysisContent.answer]}}</span>
      <span class="it-li" v-if="is_right">{{name}}选对了</span>
      <span class="it-li" v-if="!is_right && singleAnswer!==null">{{name}}错选{{optionMap[singleAnswer]}}</span>
      <span class="it-li" v-if="!is_right && singleAnswer===null" style="color:red;">{{name}}未选择答案</span>
      <span class="it-li">+{{student_score}}分</span>
    </div>
    <div class="question-analysis" v-if="analysisContent.content">
      <span>答案解析:</span>
      {{analysisContent.content}}
      <viewer :images="analysisContent.file">
        <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'currentIndex', 'name'],
  watch: {
    currentIndex: function () {
      this.initData()
    }
  },
  data() {
    return {
      singleAnswer: '',//单选答案
      optionsContent: [],
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H', 8: 'I', 9: 'J',
      },
    }
  },
  mounted() {
    this.initData()
    // this.is_right = this.singleAnswer===this.analysisContent.answer?true:false
  },
  methods: {
    initData: function () {
      this.singleAnswer = this.itemContent.student_answer
      this.titleId = this.itemContent.id
      this.optionsContent = this.itemContent.answer
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
      this.is_right = this.itemContent.right_and_wrong
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
    },
    isRight: function (index) {
      let cls = ''
      if (index === '') {
        if (this.is_right) {
          cls += ' is-right'
        } else {
          cls += ' is-wrong'
        }
      } else {
        if (this.singleAnswer === index) {
          if (this.is_right) {
            cls += ' is-right'
          } else {
            cls += ' is-wrong'
          }
        }
      }
      return cls
    }
  }
}
</script>

<style scoped="">
</style>